import { Provider } from 'react-redux'
// import { Config } from '@vkontakte/superappkit'
import { BrowserRouter } from 'react-router'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/ru'
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { message } from 'antd'
import { JointContent } from 'antd/es/message/interface'
import { I18nextProvider } from 'react-i18next'
// import { vkAppId } from './constants/vk'
import { AppProvider } from './context'
import Router from './Router'
import { store } from './store'
import i18next from './helpers/i18n'
import * as Sentry from '@sentry/react'

dayjs.locale('ru')
dayjs.extend(customParseFormat)

const App = () => {
  // Config.init({
  //   appId: vkAppId
  // })

  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (query?.meta?.errorMessage) {
          Sentry.captureException(error, {
            extra: { queryKey: query.queryKey }
          })
          message.error(query.meta.errorMessage as JointContent)
        }
        //  else {
        // message.error('При получении данных произошла ошибка')
        // }
      }
    })
  })

  return (
    <BrowserRouter>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <I18nextProvider i18n={i18next}>
            <AppProvider>
              <Router />
            </AppProvider>
          </I18nextProvider>
        </QueryClientProvider>
      </Provider>
    </BrowserRouter>
  )
}

export default App
